import { useState } from 'react';
import { useQueryClient } from 'react-query';

import { queries } from '~/constants/queryKeys';
import { RequireAuthentication } from '~/helpers/RequireAuthentication';
import { ConnectSourceModalKey, UrlModalHelper } from '~/helpers/UrlModalHelper';
import { Modal } from '~/vinovest-design-system/components';

import { ConnectSourceModalContent } from './ConnectSourceModalContent';
import { observer } from 'mobx-react-lite';

/** Modal where user can view deposit instructions or connect an external deposit source through. */
export const ConnectSourceModal = observer(() => {
    const [plaidComplete, setIsPlaidComplete] = useState(true);
    const queryClient = useQueryClient();

    const open = UrlModalHelper.isModalOpen(ConnectSourceModalKey);

    const setNewOpenHandler = (setOpen: boolean) => {
        if (!plaidComplete) {
            return;
        }
        if (setOpen) {
            UrlModalHelper.open(ConnectSourceModalKey);
        } else {
            UrlModalHelper.close(ConnectSourceModalKey);
        }
    };

    return (
        <RequireAuthentication>
            <Modal
                open={open}
                setOpen={setNewOpenHandler}
                classnames={` w-full print:w-full md:max-w-[660px]`}
                modalKey={ConnectSourceModalKey}
            >
                <ConnectSourceModalContent
                    setIsPlaidComplete={setIsPlaidComplete}
                    onPaymentAdded={() => {
                        void queryClient.invalidateQueries([queries.getSavedPaymentMethods]);
                        UrlModalHelper.close(ConnectSourceModalKey, true);
                    }}
                />
            </Modal>
        </RequireAuthentication>
    );
});

export default ConnectSourceModal;
